import React from 'react';
import { InView } from 'react-intersection-observer';

import IconArrow from '@components/Images/IconArrow';
import useEventTracking from '@hooks/useEventTracking';
import MuxPlayer from '@mux/mux-player-react';
import { titv_show_path } from '@routes';
import { ImpressionElement, impression } from '@tracking';

import { VideoPlayerProps } from './interfaces';

const VideoPlayer = ({ video }: VideoPlayerProps) => {
  const { trackEvent } = useEventTracking();

  return (
    <InView
      triggerOnce={true}
      onChange={(inView) => {
        inView &&
          trackEvent(
            impression({ impressionElement: ImpressionElement.Video, context: video.guid })
          );
      }}
    >
      <div className="px-0 sm:px-28">
        <div className="m-auto max-w-container-lg">
          <div className="flex flex-wrap items-start gap-12 sm:flex-nowrap sm:gap-32 md:gap-56">
            <div
              className={`w-full flex-shrink-0 sm:max-w-[50%] ${
                video.videoType === 'short' ? 'lg:max-w-[360px]' : 'lg:max-w-[747px]'
              }`}
            >
              <MuxPlayer
                playbackId={video.playbackId}
                metadataVideoTitle={video.title}
                accentColor="#e0194b"
                style={{
                  width: '100%',
                  aspectRatio: video.videoType === 'short' ? '9/16' : '16/9',
                }}
              />
            </div>
            <div className="flex w-full flex-col px-28 pb-40 sm:pb-56 sm:pl-0">
              {video.title && (
                <h1 className="m-0 font-suisse-works text-headline-xxs md:text-headline-xs lg:text-headline-sm">
                  {video.title}
                </h1>
              )}
              {video.createdAtIso && (
                <time
                  className="font-suisse-screen text-disclosure-sm text-grayscale-charcoal"
                  dateTime={video.createdAtIso}
                >
                  {video.createdAtFormatted}
                </time>
              )}
              {video.titvStreamGuid && (
                <div className="mt-24">
                  <a
                    className="group flex flex-nowrap items-center font-suisse-intl-mono text-disclosure-md text-primary-magenta"
                    href={titv_show_path({ guid: video.titvStreamGuid })}
                  >
                    See Full Episode
                    <IconArrow className="mb-4 ml-24 h-16 flex-shrink-0 rotate-180 text-primary-magenta transition-transform duration-200 group-hover:translate-x-2" />
                  </a>
                </div>
              )}
            </div>
          </div>
          <div className="mx-28 border-0 border-b border-solid pt-0 sm:mx-0 sm:pt-56" />
        </div>
      </div>
    </InView>
  );
};

export default VideoPlayer;
